module.exports = __webpack_public_path__ + "fb484ddc9d7e580b181b0fbe061dad28.svg";